import { ContextualMenuItemType } from 'office-ui-fabric-react/lib/ContextualMenu';

export function getDividerForContextMenu(key: string) {
    return {
        key: key,
        itemType: ContextualMenuItemType.Divider,
    };
}
